import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { CalDavStore } from './CalDavStore';

const CalDavStoreContext = createContext<CalDavStore | null>(null);

export const CalDavStoreProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const store = useMemo(() => new CalDavStore(), []);

  return <CalDavStoreContext.Provider value={store}>{children}</CalDavStoreContext.Provider>;
};

export const useCalDavStore = (): CalDavStore => {
  const store = useContext(CalDavStoreContext);

  if (!store) {
    throw new Error('useCalDavStore must be used within CalDavStoreProvider');
  }

  return store;
};
